import { Button } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useQueryModeloImportacao } from 'pages/cadastro/loja-importacao/hooks/useQueryModeloImportacao';

export function LojaImportacaoModeloBtn() {
    const { refetch } = useQueryModeloImportacao();

    return (
        <Button variant="outlined" color="success" startIcon={<RiFileExcel2Fill />} onClick={() => refetch()}>
            Download do modelo do arquivo
        </Button>
    );
}
